import { IBlock } from "../../../framework/src/IBlock";
import { Message } from "../../../framework/src/Message";
import { BlockComponent } from "../../../framework/src/BlockComponent";
import MessageEnum, {
  getName,
} from "../../../framework/src/Messages/MessageEnum";
import { runEngine } from "../../../framework/src/RunEngine";
// Customizable Area Start
import { getStorageData } from "../../../framework/src/Utilities";

export const configJSON = require("./config");

export interface Props {
  navigation: {
    navigate: (routeName: string) => void;
    goBack: () => void;
    history: {
      push: (path: string) => void;
    };
  };
  id: string;
}

interface IRuleType {
  id: number;
  name: string;
  code: string;
}

interface IConfig {
  id: number;
  // Type 1: Day & Time Based
  days_of_week?: number[];
  day_names?: string[];
  start_time?: string;
  end_time?: string;
  // Type 2: Late Delivery
  delay_hours?: number;
  applicable_days?: number[];
  // Type 3: Special Day
  special_day_name?: string;
  special_day_date?: string;
  formatted_date?: string;
  is_recurring?: boolean;
  // Type 4: Upcharge Based
  upcharge_list_id?: number;
  upcharge_list_name?: string;
  requires_all_items?: boolean;
}

interface ICategory {
  id: number;
  name: string;
}

interface ICatalogue {
  id: number;
  name: string;
}

interface IPlatform {
  id: number;
  name: string;
}

interface IRegion {
  id: number;
  name?: string;
  branch_name?: string;
}

interface IArea {
  id: number;
  area_name?: string;
  name?: string;
}

interface IStore {
  id: number;
  store_name?: string;
  name?: string;
}

interface IMultiplierRule {
  id: string;
  type: string;
  attributes: {
    id: number;
    name: string;
    description: string;
    multiplier: string;
    is_active: boolean;
    priority: number;
    start_date: string;
    end_date: string | null;
    created_at: string;
    updated_at: string;
    rule_type: IRuleType;
    config: IConfig;
    categories: ICategory[];
    catalogues: ICatalogue[];
    platforms: IPlatform[];
    regions: IRegion[];
    areas: IArea[];
    stores: IStore[];
    applies_to_all_categories: boolean;
    applies_to_all_catalogues: boolean;
  };
}

interface S {
  multiplierRule: IMultiplierRule | null;
  isLoading: boolean;
  ruleId: string;
}

interface SS {
  id: string;
}

export default class ViewLoyaltyMultiplierController extends BlockComponent<
  Props,
  S,
  SS
> {
  getMultiplierRuleCallId: string = "";

  constructor(props: Props) {
    super(props);
    this.receive = this.receive.bind(this);

    this.subScribedMessages = [
      getName(MessageEnum.AccoutLoginSuccess),
      getName(MessageEnum.RestAPIResponceSuccessMessage),
      getName(MessageEnum.RestAPIResponceDataMessage),
      getName(MessageEnum.RestAPIResponceMessage),
    ];

    this.state = {
      multiplierRule: null,
      isLoading: true,
      ruleId: "",
    };
    runEngine.attachBuildingBlock(this as IBlock, this.subScribedMessages);
  }

  async receive(from: string, message: Message) {
    if (getName(MessageEnum.RestAPIResponceMessage) === message.id) {
      const apiRequestCallId = message.getData(
        getName(MessageEnum.RestAPIResponceDataMessage)
      );

      if (apiRequestCallId === this.getMultiplierRuleCallId) {
        this.receiveMultiplierRule(message);
      }
    }
  }

  receiveMultiplierRule = (message: Message) => {
    const responseJson = message.getData(
      getName(MessageEnum.RestAPIResponceSuccessMessage)
    );

    this.setState({ isLoading: false });

    if (responseJson && responseJson.data) {
      this.setState({ multiplierRule: responseJson.data });
    }
  };

  async componentDidMount() {
    super.componentDidMount();
    const ruleId = localStorage.getItem("loyaltyMultiplierId") || "";
    this.setState({ ruleId }, () => {
      if (ruleId) {
        this.getMultiplierRule(ruleId);
      }
    });
  }

  getMultiplierRule = async (ruleId: string) => {
    this.setState({ isLoading: true });
    const header = {
      token: await getStorageData(configJSON.tokenKey),
      "Content-Type": configJSON.contentType,
    };
    const getDataMsg = new Message(getName(MessageEnum.RestAPIRequestMessage));
    this.getMultiplierRuleCallId = getDataMsg.messageId;

    getDataMsg.addData(getName(MessageEnum.RestAPIRequestMethodMessage), "GET");
    getDataMsg.addData(
      getName(MessageEnum.RestAPIResponceEndPointMessage),
      `bx_block_loyaltymultiplier/rules/${ruleId}`
    );
    getDataMsg.addData(
      getName(MessageEnum.RestAPIRequestHeaderMessage),
      JSON.stringify(header)
    );
    runEngine.sendMessage(getDataMsg.id, getDataMsg);
  };

  handleGoBack = () => {
    localStorage.setItem("loyaltyReturnTab", "Loyalty Multiplier");
    this.props.navigation.goBack();
  };

  // Customizable Area End
}
